const RecordsRezItem = ({ item, onClick }) => {
  const products = item.cnts.filter(i => i.objectVid === 2).map(i => i.objectName).join(', ') || '';
  const clients = item.cnts.filter(i => i.objectVid === 1).map(i => i.objectName).join(', ') || '';

  return <div className="records-rez-item" onClick={onClick}>
    <div>РЕЗЕРВ # {item.id}</div>
    {products && <div>{products}</div>}
    {clients && <div>{clients}</div>}
    {item.comment && <div>{item.comment}</div>}
    {item.userName && <div className="records-rez-item-small">{item.userName}</div>}
    {item.roomName && <div className="records-rez-item-small">{item.roomName}</div>}
  </div>
}

export default RecordsRezItem;